/**
 * Full-screen notice shown on phones. The platform's full functionality is only
 * available on a computer (Pascal review, Aug 20) — rather than ship a degraded
 * mobile layout, we block phones with a clear message.
 */
export function MobileBlockScreen() {
  return (
    <div className="mobile-block">
      <div className="mobile-block__card">
        <div className="mobile-block__mark">Orchestrator.coach</div>
        <h1>Please switch to a computer</h1>
        <p>
          The Orchestration Design Canvas is only available on a computer, where
          you have the room to design and review your canvas properly.
        </p>
        <p className="mobile-block__soft">
          Open this page again on a laptop or desktop to get started. Thank you for
          your understanding.
        </p>
      </div>
    </div>
  );
}

/** True on phones / small touch screens (not desktop windows resized narrow). */
export function isMobileDevice(): boolean {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const phoneUA = /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(ua);
  const smallTouch =
    window.innerWidth < 768 &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);
  return phoneUA || smallTouch;
}
